<!-- Bar search -->
<ng-container *ngIf="appearance === 'bar'">
    <button
        mat-icon-button
        *ngIf="!opened"
        (click)="open()">
        <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
    </button>
    <div class="absolute inset-0 flex items-center shrink-0 z-99 bg-card"
         *ngIf="opened"
         @slideInTop
         @slideOutTop>
      <mat-icon class="absolute ml-6 sm:ml-8"
                [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>


        <input  class="w-full h-full px-16 sm:px-18" type="text" placeholder="{{ 'Search' | translate}}....." aria-label="Search....."
               matInput
               [formControl]="topSearchControl"
               [matAutocomplete]="auto" (input)="onTopSearchChange($event.target.value)">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of topSearchOptions" [routerLink]="option.url" (click)="close()">
            {{option.display_name}}
          </mat-option>
        </mat-autocomplete>
 
     
      <button class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5"
              mat-icon-button
              (click)="close()">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>
</ng-container>
